import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import { getBlogs } from "@/lib/api";

export default function BlogPreview() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getBlogs()
      .then((data) => setBlogs(data.slice(0, 3)))
      .catch(() => setBlogs([]))
      .finally(() => setLoading(false));
  }, []);

  if (!loading && blogs.length === 0) return null;

  return (
    <section data-testid="blog-preview-section" className="iona-section bg-[#F8F9FA]">
      <div className="iona-container">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div className="max-w-xl">
            <div className="text-xs uppercase tracking-[0.3em] text-[#5E2A84] mb-4">
              — Blog
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1A1A1A] leading-[1.1] tracking-tight">
              Güzellik ve bakım <span className="italic text-[#5E2A84]">rehberi</span>
            </h2>
          </div>
          <Link
            to="/blog"
            data-testid="blog-preview-view-all"
            className="inline-flex items-center gap-2 text-[#5E2A84] hover:gap-3 transition-all font-medium"
          >
            Tüm Yazıları Gör
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {loading ? (
            [...Array(3)].map((_, i) => (
              <div
                key={i}
                className="h-96 bg-white rounded-3xl animate-pulse border border-[#F0F0F0]"
              />
            ))
          ) : (
            (Array.isArray(blogs) ? blogs : []).map((b) => (
              <Link
                key={b.id}
                to={`/blog/${b.slug}`}
                data-testid={`blog-preview-card-${b.slug}`}
                className="group bg-white rounded-3xl overflow-hidden border border-[#F0F0F0] iona-hover-lift block"
              >
                <div className="h-52 overflow-hidden">
                  <img
                    src={
                      b.cover_image ||
                      "https://images.pexels.com/photos/4041392/pexels-photo-4041392.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=520&w=920"
                    }
                    alt={b.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="p-7">
                  <div className="flex items-center gap-3 text-xs text-[#4A4A4A] mb-4">
                    <span className="px-3 py-1 rounded-full bg-[#F4F1F9] text-[#5E2A84] uppercase tracking-wider">
                      {b.category}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <Calendar className="w-3 h-3" />
                      {new Date(b.created_at).toLocaleDateString("tr-TR")}
                    </span>
                  </div>
                  <h3 className="font-serif text-xl text-[#1A1A1A] mb-3 leading-snug group-hover:text-[#5E2A84] transition-colors line-clamp-2">
                    {b.title}
                  </h3>
                  <p className="text-sm text-[#4A4A4A] leading-relaxed line-clamp-3">
                    {b.excerpt}
                  </p>
                </div>
              </Link>
            ))
          )}
        </div>
      </div>
    </section>
  );
}
